import React from 'react';
import {CustomDropdown, CheckboxMenuItem} from 'epic-ue-ui';
import {Counts} from '../jobs.fetch';

interface Props {
    toggleCheckboxFilter: (e: any, filterName: string, value: string) => void;
    jobsFilters?: any;
    counts?: Counts;
    productLabel?: string;
    companyLabel?: string;
    typeLabel?: string;
}

interface LabelProps {
    productLabel?: string;
    companyLabel?: string;
    typeLabel?: string;
}

const standardDropdownKeys = ['Product', 'Company', 'Type'];

const getLabel = (
    filterName: string,
    {productLabel, companyLabel, typeLabel}: LabelProps
): string => {
    switch (filterName) {
        case 'Product':
            return productLabel || 'Product';
            break;

        case 'Company':
            return companyLabel || 'Company';
            break;

        case 'Type':
            return typeLabel || 'Type';
            break;

        default:
            return filterName || 'Filter';
            break;
    }
};

export const StandardDropdowns = ({
    toggleCheckboxFilter,
    jobsFilters,
    counts,
    productLabel,
    companyLabel,
    typeLabel
}: Props): JSX.Element => {
    return (
        <>
            {standardDropdownKeys.map((filterName, i) => {
                const filterNameLower = filterName.toLocaleLowerCase();

                return (
                    <CustomDropdown
                        label={getLabel(filterName, {productLabel, companyLabel, typeLabel})}
                        hasCheckedItems={jobsFilters[filterNameLower] !== undefined}
                        key={i}>
                        {counts?.[filterName.toLocaleLowerCase()] &&
                            Object.keys(counts?.[filterNameLower] || {})
                                .sort()
                                .map((keyName, j) => {
                                    const checked =
                                        jobsFilters?.[filterNameLower]?.includes(keyName) || false;
                                    let disabled = false;
                                    if (counts?.[filterNameLower]?.[keyName] === 0) {
                                        disabled = true;
                                    }
                                    return (
                                        !disabled && (
                                            <CheckboxMenuItem
                                                key={`menu-item-${keyName}-${j}`}
                                                checkboxProps={{
                                                    checked,
                                                    disabled
                                                }}
                                                onClick={(e) =>
                                                    !disabled &&
                                                    toggleCheckboxFilter(
                                                        e,
                                                        filterNameLower,
                                                        keyName
                                                    )
                                                }>
                                                {`${keyName} (${counts?.[filterNameLower]?.[keyName]}) `}{' '}
                                            </CheckboxMenuItem>
                                        )
                                    );
                                })}
                    </CustomDropdown>
                );
            })}
        </>
    );
};
